







































import {
	computed,
	defineComponent,
	PropType,
	ref,
} from '@vue/composition-api';
import { ReadStatus } from '@front-app/services/NoteApi/NoteModels';
import { UserAvatarStore, UserStore } from '@front-app/store/singletons/User';
import { Size } from '@front-app/components/constants';
import { PartialUser } from '@front-app/services/UserApi/UserModel';
import { getUsername } from '@front-app/util/user';
import { useOnEntry } from '@front-app/hooks/useOnEntry';
import UserAvatar from '@front-app/components/user/avatar.vue';
import UserLink from '../buttons/UserLink.vue';

export default defineComponent({
	components: {
		UserLink,
		UserAvatar,
	},
	props: {
		authorId: {
			type: String,
			required: true,
		},
		message: {
			type: String,
			required: true,
		},
		creationDateTime: {
			type: String,
			required: true,
		},
		readStatus: {
			type: String as PropType<ReadStatus>,
			required: true,
		},
	},
	setup(props, ctx) {
		const el = ref(null);
		if (props.readStatus !== ReadStatus.READ) {
			useOnEntry(el, () => ctx.emit('view'));
		}
		const userStore = UserStore.getInstance();
		const author = computed(() => userStore.getPartial(props.authorId).value);
		const getUsernameInternal = (user: PartialUser): string => getUsername(ctx.root.$t.bind(ctx.root), user);
		return {
			el,
			author,
			// Avatar
			fetchAvatar: UserAvatarStore.fetch,
			getAvatar: UserAvatarStore.get,
			// Util
			Size,
			getUsernameInternal,
		};
	},
});
